function RubricIcon({ fill }: string | any | { fill: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        fill={fill ? fill : "#2c2c2c"}
        d="M1.999 11.64v2.027a.33.33 0 00.333.334H4.36a.313.313 0 00.233-.1l7.28-7.274-2.5-2.5L2.1 11.401a.327.327 0 00-.1.24zm11.807-6.946c.26-.26.26-.68 0-.94l-1.56-1.56a.664.664 0 00-.94 0l-1.22 1.22 2.5 2.5 1.22-1.22z"
      ></path>
    </svg>
  );
}
export default RubricIcon;
